module.exports = __webpack_public_path__ + "media/images/countryrect/uy-2aeb823f027b9ccbc76b4c5e8eac0ef7.svg";